'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = {
  // Options.jsx
  items_per_page: '/ strana',
  jump_to: 'Choď na',
  page: '',

  // Pagination.jsx
  prev_page: 'Predchádzajúca strana',
  next_page: 'Nasledujúca strana',
  prev_5: 'Predchádzajúcich 5 strán',
  next_5: 'Nasledujúcich 5 strán',
  prev_3: 'Predchádzajúce 3 strany',
  next_3: 'Nasledujúce 3 strany'
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/._rc-pagination@1.8.2@rc-pagination/lib/locale/sk_SK.js
 ** module id = 812
 ** module chunks = 1
 **/